export const ItemTypes = {
    PLANNER_LOCATION: 'PLANNER_LOCATION',
}

export const Targets = {
    PLANNER_TIMELINE: 'PLANNER_TIMELINE',
    PLANNER_TIMELINE_CANNOT_ADD: 'PLANNER_TIMELINE_CANNOT_ADD',
    AD_HOC_REQUESTS: 'AD_HOC_REQUESTS',
    REQUESTED: 'REQUESTED',
}